import axios from 'axios';

let lang;

if (
	window.Telegram.WebApp.platform === 'android' ||
	window.Telegram.WebApp.platform === 'ios' ||
	window.Telegram.WebApp.platform === 'android_x' ||
	process.env.VITE_ENV_APP === 'dev' ||
	process.env.VITE_ENV_APP === 'int'
) {
	lang = localStorage.getItem('lang_selected');
} else {
	window.Telegram.WebApp.CloudStorage.getItem('lang_selected', (_, res) => {
		lang = res;
	});
}

const INIT_DATA = import.meta.env.DEV
	? import.meta.env.VITE_LOCAL_INIT_DATA
	: window.Telegram.WebApp.initData;

const isPremium: Boolean =
	window.Telegram.WebApp.initDataUnsafe.user?.is_premium || false;

export const axiosDefault = axios.create();
axiosDefault.defaults.baseURL = process.env.VITE_API_URL;
axiosDefault.defaults.headers.common['Authorization'] = `Bearer ${INIT_DATA}`;
axiosDefault.defaults.headers.common['x-language'] = lang;
axiosDefault.defaults.headers.common['x-premium'] = isPremium.toString();
